module.exports = {"id":"167653","name":"Magnus Troest","rating":"72","photo":"./data/images/photos/4/167653.png","club":{"name":"Novare","logo":"./data/images/clubs/Novare.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MagnusTroest0.json
// module id = 2656
// module chunks = 0